<template>
  <div
    class="clearable-form-datepicker"
    :class="{ 'clearable-form-datepicker--has-value': hasValue }"
  >
    <b-form-datepicker
      :value="value"
      v-bind="$attrs"
      @input="onInput"
    />
    <button
      v-if="hasValue"
      type="button"
      class="clearable-form-datepicker__clear vs__clear"
      title="Clear Selected"
      aria-label="Clear Selected"
      @mousedown.prevent
      @click="clear"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="10"
        height="10"
      >
        <path d="M6.895455 5l2.842897-2.842898c.348864-.348863.348864-.914488 0-1.263636L9.106534.261648c-.348864-.348864-.914489-.348864-1.263636 0L5 3.104545 2.157102.261648c-.348863-.348864-.914488-.348864-1.263636 0L.261648.893466c-.348864.348864-.348864.914489 0 1.263636L3.104545 5 .261648 7.842898c-.348864.348863-.348864.914488 0 1.263636l.631818.631818c.348864.348864.914773.348864 1.263636 0L5 6.895455l2.842898 2.842897c.348863.348864.914772.348864 1.263636 0l.631818-.631818c.348864-.348864.348864-.914489 0-1.263636L6.895455 5z" />
      </svg>
    </button>
  </div>
</template>

<script>
import { BFormDatepicker } from 'bootstrap-vue'

export default {
  components: {
    BFormDatepicker,
  },
  inheritAttrs: false,
  props: {
    value: {
      type: [String, null],
      default: null,
    },
  },
  computed: {
    hasValue() {
      return Boolean(this.value)
    },
  },
  methods: {
    onInput(val) {
      this.$emit('input', val || null)
    },
    clear() {
      this.$emit('input', null)
    },
  },
}
</script>
